// extracted by mini-css-extract-plugin
export var actionButton = "_6i-0";
export var attachmentLine = "_6i-1";
export var fileInput = "_6i-2";
export var fileUploadWrapper = "_6i-4";
export var footer = "_6i-3";
export var modalContent = "_6i-5";
export var paperclip = "_6i-6";
export var quillEditor = "_6i-7";